define('webshopAttributesKeyView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'buttonView',
  'modalView',
  'modalsAlertView',
  'modalsConfirmationView',
  'webshopAttributesEditView',
  'webshopAttributesMergeView',
  'webshopAttributesSupplierValuesView',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesKeyView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  ButtonView,
  ModalView,
  AlertView,
  ConfirmationView,
  EditView,
  MergeView,
  SupplierValuesView,
  MatchingApi,
  Tpl
) {
  'use strict';

  // One canonical attribute: its values, the supplier customfields matched onto it and their
  // values. options: key, meta {languages, suppliers}, onChanged(key), onDeleted().
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-attributes-key-view',

    regions: {
      editRegion: '.edit-region',
      deleteRegion: '.delete-region',
      refreshRegion: '.refresh-region',
      addValueRegion: '.add-value-region',
      addFieldsRegion: '.add-fields-region',
      supplierValuesRegion: '.supplier-values-region'
    },

    ui: {
      refreshStatus: '.refresh-status',
      values: '.values',
      fields: '.fields'
    },

    events: {
      'click .subtab': 'onSubtab',
      'click .value .edit': 'onEditValue',
      'click .value .delete': 'onDeleteValue',
      'click .value .merge': 'onMergeValue',
      'click .field .unmatch': 'onUnmatchField'
    },

    initialize: function () {
      this.key = this.options.key;
      this.values = [];
      this.fields = [];
      var state = this.options.state || {};
      this.subtab = _.contains(['values', 'fields', 'supplier-values'], state.sub) ? state.sub : 'values';
      // Filters of the supplier values pane (kept when it is redrawn, and in the URL)
      this.supplierValuesState = {q: state.q || '', sup: state.sup || '', unm: state.unm === '1'};
    },

    serializeData: function () {
      return {
        key: this.key,
        name: MatchingApi.name(this.key),
        names: _.map(this.key.names, function (n, l) { return {lang: l, name: n}; }),
        subtab: this.subtab
      };
    },

    onRender: function () {
      var edit = new ButtonView({type: 'edit', text: _.i18n('common.edit', null, 'Edit')});
      edit.on('click', _.bind(this.onEdit, this));
      this.getRegion('editRegion').show(edit);

      var remove = new ButtonView({type: 'remove', text: _.i18n('common.delete', null, 'Delete')});
      remove.on('click', _.bind(this.onDelete, this));
      this.getRegion('deleteRegion').show(remove);

      var refresh = new ButtonView({type: 'reload', text: _.i18n('attributeMatching.republish', null, 'Republish the filters')});
      refresh.on('click', _.bind(this.onRefresh, this));
      this.getRegion('refreshRegion').show(refresh);

      var addValue = new ButtonView({type: 'add', color: 'orange', text: _.i18n('attributeMatching.addValue', null, 'New value')});
      addValue.on('click', _.bind(this.onAddValue, this));
      this.getRegion('addValueRegion').show(addValue);

      var addFields = new ButtonView({type: 'add', color: 'orange', text: _.i18n('attributeMatching.addFields', null, 'Match supplier fields')});
      addFields.on('click', _.bind(this.onAddFields, this));
      this.getRegion('addFieldsRegion').show(addFields);

      this.showSubtab();
      this.fetchValues();
      this.fetchFields();
      this.pollRefresh();
    },

    onDestroy: function () {
      clearTimeout(this.refreshTimer);
    },

    //----------------
    // Sub tabs

    onSubtab: function (e) {
      this.subtab = $(e.currentTarget).data('tab');
      if (this.options.onState)
        this.options.onState({sub: this.subtab === 'values' ? null : this.subtab});
      this.showSubtab();
    },

    showSubtab: function () {
      this.$('.subtab').removeClass('active');
      this.$('.subtab[data-tab="' + this.subtab + '"]').addClass('active');
      this.$('.pane').hide();
      this.$('.pane[data-tab="' + this.subtab + '"]').css('display', 'flex');

      if (this.subtab === 'supplier-values') {
        this.getRegion('supplierValuesRegion').show(new SupplierValuesView({
          key: this.key,
          values: this.values,
          meta: this.options.meta,
          state: this.supplierValuesState,
          onState: _.bind(function (filters) {
            this.supplierValuesState = filters;
            if (this.options.onState)
              this.options.onState({q: filters.q, sup: filters.sup, unm: filters.unm});
          }, this),
          onChanged: _.bind(this.fetchValues, this)
        }));
      } else {
        this.getRegion('supplierValuesRegion').empty();
      }
    },

    //----------------
    // Values

    fetchValues: function () {
      this.ui.values.addClass('am-loading');
      return MatchingApi.values(this.key.id).done(_.bind(function (values) {
        // Mutated in place: the supplier values view keeps a reference to this array.
        this.values.length = 0;
        _.each(values, function (v) { this.values.push(v); }, this);
        if (!this.isDestroyed)
          this.renderValues();
      }, this)).fail(_.bind(this.showError, this)).always(_.bind(function () {
        if (!this.isDestroyed)
          this.ui.values.removeClass('am-loading');
      }, this));
    },

    renderValues: function () {
      var lang = this.options.meta.languages;
      var labels = MatchingApi.labels(this.values);
      var duplicates = MatchingApi.duplicateIds(this.values);
      var html = _.map(_.sortBy(this.values, function (v) { return MatchingApi.name(v).toLowerCase(); }), function (v) {
        var color = MatchingApi.color(v);
        var others = _.map(_.omit(v.names, _.first(lang)), function (n, l) { return l + ': ' + n; }).join(' · ');
        return '<div class="value" data-id="' + v.id + '">' +
          '<div class="col-color">' + (color ? '<span class="am-swatch" style="background:' + _.escape(color) + '"></span>' : '') + '</div>' +
          '<div class="col-name"><div class="main">' + _.escape(labels[v.id]) +
          (_.contains(duplicates, v.id) ? ' <span class="am-badge duplicate" title="' + _.escape(_.i18n('attributeMatching.duplicateHint', null, 'Another value has the same name: merge them')) + '">' +
            _.escape(_.i18n('attributeMatching.duplicate', null, 'duplicate')) + '</span>' : '') + '</div>' +
          (others ? '<div class="others">' + _.escape(others) + '</div>' : '') + '</div>' +
          '<div class="col-code">' + _.escape(v.code) + '</div>' +
          '<div class="col-param">' + (color ? '' : _.escape(v.extraParam1 || '')) + '</div>' +
          '<div class="col-count" title="' + _.escape(_.i18n('attributeMatching.attributeMatches', null, 'Supplier values shown as this value')) + '">' + v.attributeMatchCount + '</div>' +
          '<div class="col-count" title="' + _.escape(_.i18n('attributeMatching.filterMatches', null, 'Supplier values filtered under this value')) + '">' + v.filterMatchCount + '</div>' +
          '<div class="col-tools">' +
          '<span class="merge" title="' + _.escape(_.i18n('attributeMatching.mergeInto', null, 'Merge into another value')) + '"><i class="fa fa-compress"></i></span>' +
          '<span class="edit" title="' + _.escape(_.i18n('common.edit', null, 'Edit')) + '"><i class="fa fa-pencil"></i></span>' +
          '<span class="delete" title="' + _.escape(_.i18n('common.delete', null, 'Delete')) + '"><i class="fa fa-trash"></i></span>' +
          '</div></div>';
      }).join('');
      this.ui.values.html(html || '<div class="empty">' + _.i18n('attributeMatching.noValue', null, 'No value yet') + '</div>');
      this.$('.values-count').text(this.values.length);
    },

    getValue: function (e) {
      var id = parseInt($(e.currentTarget).closest('.value').data('id'), 10);
      return _.findWhere(this.values, {id: id});
    },

    openValueEditor: function (title, value, onConfirm) {
      ModalView.prototype.open({
        childView: EditView,
        kind: 'value',
        languages: this.options.meta.languages,
        model: new Backbone.Model(value ? _.pick(value, 'id', 'code', 'names', 'extraParam1') : {code: '', names: {}, extraParam1: ''}),
        title: title,
        confirmButtonText: _.i18n('common.save', null, 'Save'),
        onConfirm: onConfirm
      });
    },

    onAddValue: function () {
      this.openValueEditor(_.i18n('attributeMatching.addValue', null, 'New value'), null, _.bind(function (model) {
        MatchingApi.addValue(this.key.id, model.toJSON())
          .done(_.bind(this.valuesChanged, this)).fail(_.bind(this.showError, this));
      }, this));
    },

    onEditValue: function (e) {
      var value = this.getValue(e);
      this.openValueEditor(_.i18n('attributeMatching.editValue', null, 'Edit value'), value, _.bind(function (model) {
        MatchingApi.updateValue(this.key.id, value.id, model.toJSON())
          .done(_.bind(this.valuesChanged, this)).fail(_.bind(this.showError, this));
      }, this));
    },

    onDeleteValue: function (e) {
      var value = this.getValue(e);
      ConfirmationView.prototype.open({
        text: _.i18n('attributeMatching.deleteValueConfirm', null,
          'Delete the value "%s"? Its %d supplier matchings are removed too.')
          .replace('%s', MatchingApi.name(value)).replace('%d', value.attributeMatchCount + value.filterMatchCount),
        onConfirm: _.bind(function () {
          MatchingApi.removeValue(this.key.id, value.id)
            .done(_.bind(this.valuesChanged, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    onMergeValue: function (e) {
      var value = this.getValue(e);
      if (this.values.length < 2)
        return;
      ModalView.prototype.open({
        childView: MergeView,
        value: value,
        values: this.values,
        model: new Backbone.Model({intoId: null}),
        title: _.i18n('attributeMatching.mergeInto', null, 'Merge into another value'),
        confirmButtonText: _.i18n('attributeMatching.merge', null, 'Merge'),
        onConfirm: _.bind(function (model) {
          if (!model.get('intoId'))
            return;
          MatchingApi.mergeValue(this.key.id, value.id, model.get('intoId'))
            .done(_.bind(this.valuesChanged, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    valuesChanged: function () {
      this.fetchValues().done(_.bind(function () {
        if (this.subtab === 'supplier-values')
          this.showSubtab();
      }, this));
      if (this.options.onChanged)
        this.options.onChanged();
    },

    //----------------
    // Supplier fields

    fetchFields: function () {
      this.ui.fields.addClass('am-loading');
      return MatchingApi.supplierFields({keyId: this.key.id, pageSize: 500}).done(_.bind(function (page) {
        this.fields = page.items;
        if (!this.isDestroyed)
          this.renderFields();
      }, this)).fail(_.bind(this.showError, this)).always(_.bind(function () {
        if (!this.isDestroyed)
          this.ui.fields.removeClass('am-loading');
      }, this));
    },

    renderFields: function () {
      var html = _.map(this.fields, function (f) {
        return '<div class="field" data-id="' + f.customFieldId + '">' +
          '<span class="supplier">' + _.escape(f.supplierCode) + '</span>' +
          '<span class="code">' + _.escape(f.code) + '</span>' +
          '<span class="field-name">' + _.escape(f.name || '') + '</span>' +
          '<span class="count">' + f.valueCount + ' ' + _.escape(_.i18n('attributeMatching.values', null, 'values')) + '</span>' +
          '<span class="unmatch" title="' + _.escape(_.i18n('attributeMatching.unmatch', null, 'Remove the matching')) + '"><i class="fa fa-times"></i></span>' +
          '</div>';
      }).join('');
      this.ui.fields.html(html || '<div class="empty">' + _.i18n('attributeMatching.noField', null, 'No supplier field matched yet') + '</div>');
      this.$('.fields-count').text(this.fields.length);
    },

    onAddFields: function () {
      require(['webshopAttributesFieldsPickerView'], _.bind(function (PickerView) {
        PickerView.prototype.open({
          key: this.key,
          meta: this.options.meta,
          onChanged: _.bind(this.fieldsChanged, this)
        });
      }, this));
    },

    onUnmatchField: function (e) {
      var id = parseInt($(e.currentTarget).closest('.field').data('id'), 10);
      var field = _.findWhere(this.fields, {customFieldId: id});
      ConfirmationView.prototype.open({
        text: _.i18n('attributeMatching.unmatchConfirm', null,
          'Remove the matching of %s? The matching of its values onto this attribute is removed too.')
          .replace('%s', field.supplierCode + ' / ' + field.code),
        onConfirm: _.bind(function () {
          MatchingApi.matchFields([id], null).done(_.bind(this.fieldsChanged, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    fieldsChanged: function () {
      this.fetchFields();
      this.fetchValues();
      if (this.subtab === 'supplier-values')
        this.showSubtab();
      if (this.options.onChanged)
        this.options.onChanged();
    },

    //----------------
    // Attribute

    onEdit: function () {
      ModalView.prototype.open({
        childView: EditView,
        kind: 'key',
        languages: this.options.meta.languages,
        model: new Backbone.Model(_.pick(this.key, 'id', 'code', 'names', 'showInFilters', 'showInAttributes')),
        title: _.i18n('attributeMatching.editKey', null, 'Edit attribute'),
        confirmButtonText: _.i18n('common.save', null, 'Save'),
        onConfirm: _.bind(function (model) {
          MatchingApi.updateKey(this.key.id, model.toJSON()).done(_.bind(function (key) {
            if (this.options.onChanged)
              this.options.onChanged(key);
          }, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    onDelete: function () {
      ConfirmationView.prototype.open({
        text: _.i18n('attributeMatching.deleteKeyConfirm', null,
          'Delete the attribute "%s", its %d values and the matching of its %f supplier fields? Republish its filters first if products carry it.')
          .replace('%s', MatchingApi.name(this.key)).replace('%d', this.key.valueCount).replace('%f', this.key.supplierFieldCount),
        onConfirm: _.bind(function () {
          MatchingApi.removeKey(this.key.id).done(_.bind(function () {
            if (this.options.onDeleted)
              this.options.onDeleted();
          }, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    //----------------
    // Webshop push

    onRefresh: function () {
      ConfirmationView.prototype.open({
        text: _.i18n('attributeMatching.republishConfirm', null,
          'Push again to the webshop the filters of every product carrying this attribute? It runs in the background and may take a few minutes.'),
        onConfirm: _.bind(function () {
          MatchingApi.refresh(this.key.id).done(_.bind(function (status) {
            this.renderRefresh(status);
            this.pollRefresh();
          }, this)).fail(_.bind(this.showError, this));
        }, this)
      });
    },

    pollRefresh: function () {
      clearTimeout(this.refreshTimer);
      MatchingApi.refreshStatus().done(_.bind(function (status) {
        if (this.isDestroyed)
          return;
        this.renderRefresh(status);
        if (status.running)
          this.refreshTimer = setTimeout(_.bind(this.pollRefresh, this), 3000);
      }, this));
    },

    renderRefresh: function (status) {
      var text = '';
      if (status && status.keyId === this.key.id) {
        if (status.running)
          text = _.i18n('attributeMatching.republishRunning', null, 'Republishing: %d / %t products')
            .replace('%d', status.done).replace('%t', status.total);
        else if (status.finishedAt)
          text = _.i18n('attributeMatching.republishDone', null, 'Last republish: %t products (%f failed)')
            .replace('%t', status.total).replace('%f', status.failed) + (status.error ? ' — ' + status.error : '');
      } else if (status && status.running) {
        text = _.i18n('attributeMatching.republishOther', null, 'Another attribute is being republished');
      }
      this.ui.refreshStatus.text(text);
    },

    showError: function (message) {
      AlertView.prototype.open('', message);
    }
  });
});

